"use client";

import { Label } from "~/components/ui/label";
import ColorPicker from "~/app/(auth-protected-routes)/projects/[id]/components/visual-settings/settings/color-picker";
import { cn } from "~/lib/utils";
import type { HireWizardWidgetColors } from "~/lib/marketplace/hire-wizard-draft";

type HireWizardWidgetColorsSectionProps = {
  colors: HireWizardWidgetColors;
  onChange: (next: HireWizardWidgetColors) => void;
  className?: string;
  title?: string;
  description?: string;
};

export function HireWizardWidgetColorsSection({
  colors,
  onChange,
  className,
  title = "Widget colors",
  description = "Customize chat widget colors for your website. Defaults are extracted from your site when available.",
}: HireWizardWidgetColorsSectionProps) {
  return (
    <div className={cn("space-y-4 rounded-lg border border-slate-200 bg-slate-50/60 p-4", className)}>
      <div>
        <h4 className="text-sm font-semibold text-slate-900">{title}</h4>
        <p className="mt-1 text-xs text-slate-500">{description}</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        <div className="space-y-2">
          <Label className="text-xs font-medium">Header color</Label>
          <ColorPicker
            value={colors.headerColor}
            onChange={(headerColor) => onChange({ ...colors, headerColor })}
          />
        </div>
        <div className="space-y-2">
          <Label className="text-xs font-medium">Header text color</Label>
          <ColorPicker
            value={colors.textColor ?? "#ffffff"}
            onChange={(textColor) => onChange({ ...colors, textColor })}
          />
        </div>
        <div className="space-y-2">
          <Label className="text-xs font-medium">Widget button color</Label>
          <ColorPicker
            value={colors.widgetButtonColor}
            onChange={(widgetButtonColor) =>
              onChange({
                ...colors,
                widgetButtonColor,
                launcherBackgroundColor: widgetButtonColor,
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
